<template lang="pug">
v-container(fluid)
  v-card(outlined)
    v-card-title.d-flex.justify-space-between
      span Etiquetas
      v-btn(color="primary" @click="openTagDialog()")
        v-icon(left) mdi-plus
        | Nueva Etiqueta
    
    v-card-text
      v-data-table(
        :headers="tagHeaders"
        :items="productTags"
        :loading="loading"
      )
        template(v-slot:item.preview="{ item }")
          v-chip(:color="item.color" small)
            v-icon(v-if="item.icon" left small) {{ item.icon }}
            | {{ item.name }}
        template(v-slot:item.active="{ item }")
          v-switch(
            v-model="item.active"
            @change="updateTag(item)"
            dense
            inset
          )
        template(v-slot:item.actions="{ item }")
          v-btn(icon small class="mr-2" @click="openTagDialog(item)")
            v-icon mdi-pencil
          v-btn(icon small color="error" @click="confirmDelete(item)")
            v-icon mdi-delete

  // Tag Dialog
  TagFormDialog(
    v-model="tagDialog"
    :tag="editedTag"
    @save="saveTag"
  )

  // Diálogo de confirmación para eliminar
  v-dialog(v-model="deleteDialog" max-width="400")
    v-card
      v-card-title ¿Eliminar etiqueta?
      v-card-text ¿Está seguro que desea eliminar esta etiqueta? Esta acción no se puede deshacer.
      v-card-actions
        v-spacer
        v-btn(text @click="deleteDialog = false") Cancelar
        v-btn(
          color="error"
          @click="deleteItem"
        ) Eliminar
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TagFormDialog from '@/components/admin/TagFormDialog.vue'

export default {
  name: 'CustomizationTags',
  
  components: {
    TagFormDialog
  },

  data: () => ({
    tagDialog: false,
    deleteDialog: false,
    loading: false,
    tagHeaders: [
      { text: 'Vista Previa', value: 'preview' },
      { text: 'Nombre', value: 'name' },
      { text: 'Activo', value: 'active' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    editedTag: {
      name: '',
      description: '',
      color: '#1976D2',
      icon: '',
      active: true
    },
    defaultTag: {
      name: '',
      description: '',
      color: '#1976D2',
      icon: '',
      active: true
    },
    itemToDelete: null
  }),

  computed: {
    ...mapState({
      productTags: state => state.productTags.list
    })
  },

  methods: {
    ...mapActions({
      fetchTags: 'productTags/fetch',
      createTag: 'productTags/create',
      updateTag: 'productTags/update',
      deleteTag: 'productTags/delete'
    }),

    openTagDialog(item = null) {
      this.editedTag = item
        ? { ...item }
        : { ...this.defaultTag }
      this.tagDialog = true
    },

    async saveTag(tagData) {
      this.loading = true
      try {
        if (tagData._id) {
          await this.updateTag(tagData)
          this.$toast.success('Etiqueta actualizada correctamente')
        } else {
          await this.createTag(tagData)
          this.$toast.success('Etiqueta creada correctamente')
        }
      } catch (error) {
        this.$toast.error('Error al guardar la etiqueta')
        console.error('Error:', error)
      } finally {
        this.loading = false
      }
    },

    confirmDelete(item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    async deleteItem() {
      this.loading = true
      try {
        await this.deleteTag(this.itemToDelete._id)
        this.$toast.success('Etiqueta eliminada correctamente')
        this.deleteDialog = false
      } catch (error) {
        this.$toast.error('Error al eliminar la etiqueta')
        console.error('Error:', error)
      } finally {
        this.loading = false
        this.itemToDelete = null
      }
    }
  },

  async created() {
    this.loading = true
    try {
      await this.fetchTags()
    } catch (error) {
      this.$toast.error('Error al cargar los datos')
      console.error('Error:', error)
    } finally {
      this.loading = false
    }
  }
}
</script>
